import { render, staticRenderFns } from "./DateFilters.vue?vue&type=template&id=1ded3926"
import script from "./DateFilters.vue?vue&type=script&lang=ts"
export * from "./DateFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports